import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import {
	loadFromSessionStorage,
	loadFromStorage,
	lsKeys,
	ssKeys,
} from '~features/storage';
import { tags } from '~features/tags/tagNames';
import { useUserTags } from '~features/tags/useUserTags';
import { useSession } from '~hooks/useSession';

export const useEmailConfirm = () => {
	const searchParams = useSearchParams();
	const {
		userTags,
		isLoading: isUserTagsLoading,
		isSuccess: isUserTagsSuccess,
	} = useUserTags();
	const {
		isDemoUser,
		isLoading: isSessionLoading,
		isSuccess: isSessionSuccess,
	} = useSession();
	const hideModal = useMemo(
		() => loadFromStorage(lsKeys.HIDE_EMAIL_CONFIRM_MODAL, false),
		[]
	);

	const confirmed = userTags.includes(tags.emailConfirmed);

	// check if session with ssKeys.CONFIRM_EMAIL to allow users to perform actions that require email verification
	const forceHidden =
		hideModal ||
		!!process.env.NEXT_PUBLIC_HIDE_EMAIL_CONFIRM ||
		loadFromSessionStorage(ssKeys.CONFIRM_EMAIL, null) === '0' ||
		searchParams.get('confirm') === '0';

	const required =
		userTags.includes(tags.emailConfirmRequired) &&
		!forceHidden &&
		!confirmed &&
		!isDemoUser;

	return {
		confirmed,
		isLoading: isSessionLoading || isUserTagsLoading,
		required,
		forceHidden,
		isSuccess: isSessionSuccess && isUserTagsSuccess,
	};
};
